<template>
  <b-modal
    id="searchModal"
    ref="modal"
    title="送信一覧検索"
    hide-footer
    :no-close-on-esc="true"
    :no-close-on-backdrop="true"
    @hidden="hideModal"
    size="lg"
  >
    <form ref="form" @submit.prevent="handleSearch">
      <div class="custom-form-block">
        <div class="form-group row">
          <h3 class="col-sm-3 col-form-label">送信日</h3>
          <div class="col-sm-5">
            <div class="form-check form-check-inline">
              <div class="col-xs-4">
                <vuejs-datepicker
                  format="yyyy-MM-dd"
                  clear-button-icon="fa fa-times"
                  :disabled-dates="disableFunction"
                  :clear-button="true"
                  :bootstrap-styling="true"
                  v-model="fromSentDateModel"
                  placeholder="From"
                ></vuejs-datepicker>
              </div>
              <div class="col-xs-4" style="margin: 5px -212px 0px 105px;">
                <vuejs-datepicker
                  format="yyyy-MM-dd"
                  clear-button-icon="fa fa-times"
                  :disabled-dates="disableFunction"
                  :clear-button="true"
                  :bootstrap-styling="true"
                  v-model="toSentDateModel"
                  placeholder="To"
                ></vuejs-datepicker>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="custom-form-block">
        <div class="form-group row">
          <h3 class="col-sm-3 col-form-label">登録者の登録 / 更新日</h3>
          <div class="col-sm-5">
            <div class="form-check form-check-inline">
              <div class="col-xs-4">
                <vuejs-datepicker
                  format="yyyy-MM-dd"
                  clear-button-icon="fa fa-times"
                  :disabled-dates="disableFunction"
                  :clear-button="true"
                  :bootstrap-styling="true"
                  v-model="fromDateModel"
                  placeholder="From"
                ></vuejs-datepicker>
              </div>
              <div class="col-xs-4" style="margin: 5px -212px 0px 105px;">
                <vuejs-datepicker
                  format="yyyy-MM-dd"
                  clear-button-icon="fa fa-times"
                  :disabled-dates="disableFunction"
                  :clear-button="true"
                  :bootstrap-styling="true"
                  v-model="toDateModel"
                  placeholder="To"
                ></vuejs-datepicker>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="form-group row mb-2">
        <h3 class="col-sm-3 col-form-label">スカウト形式</h3>
        <div class="col-sm-9" style="padding: 0px">
          <div class="row">
            <div
              class="d-flex"
              style="flex-wrap: wrap; gap: 40px; margin-left: 50px;"
            >
              <div
                v-for="contactType in contactTypes"
                :key="contactType"
                class="me-3"
              >
                <input
                  type="checkbox"
                  :id="contactType"
                  :value="contactType"
                  class="form-check-input"
                  v-model="contactTypeModel"
                />
                <label :for="contactType" class="form-check-label">{{
                  contactType
                }}</label>
                <div v-if="contactType === '通知のみ'" class="notification-note">
                  ※通知のみは、求人添付および登録者からの回答受付はできません。
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="form-group row mb-2">
        <h3 class="col-sm-3 col-form-label">回答内容</h3>
        <div class="col-sm-9" style="padding: 0px">
          <div class="row">
            <div
              class="d-flex"
              style="flex-wrap: wrap; gap: 40px; margin-left: 50px;"
            >
              <div
                v-for="responseType in responseTypes"
                :key="responseType"
                class="me-3"
                :class="{ 'application-suspension-label': responseType === '応募見合わせ' }"
              >
                <input
                  type="checkbox"
                  :id="responseType"
                  :value="responseType"
                  class="form-check-input"
                  v-model="userResponseModel"
                />
                <label 
                  :for="responseType" 
                  class="form-check-label"
                >{{
                  responseType
                }}</label>
                <div v-if="responseType === '通知のみ'" class="notification-note">
                  ※通知のみは、求人添付および登録者からの回答受付はできません。
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="form-group row mb-2">
        <h3 class="col-sm-3 col-form-label">スカウト求人キーワード</h3>
        <div class="col-sm-9" style="padding: 0px">
          <input
            type="text"
            class="form-control custom-form"
            v-model="jobQueryModel"
            style="margin-left: 15px; width: 430px; font-size:14px;"
            placeholder="複数ワードはスペース区切りで入力してください"
          />
        </div>
      </div>

      <div class="form-group row mb-2">
        <h3 class="col-sm-3 col-form-label">差出人名キーワード</h3>
        <div class="col-sm-9" style="padding: 0px">
          <input
            type="text"
            class="form-control custom-form"
            v-model="senderModel"
            style="margin-left: 15px; width: 430px; font-size:14px;"
            placeholder="複数ワードはスペース区切りで入力してください"
          />
        </div>
      </div>

    </form>
    <div class="modal-footer custom-footer justify-content-center mt-4">
      <button
        type="button"
        class="btn btn-rounded-plain mr-4"
        data-dismiss="modal"
        @click="hideModal"
      >
        キャンセル
      </button>
      <button
        type="submit"
        id="download"
        class="btn btn-rounded-md teal-bg"
        @click="handleSearch('submit')"
      >
        検索する
      </button>
    </div>
  </b-modal>
</template>

<script>
import { mapState, mapMutations, mapActions, mapGetters } from 'vuex';
import datePicker from 'vue-bootstrap-datetimepicker';
import vuejsDatepicker from 'vuejs-datepicker';

export default {
  name: 'ContactSearch',
  components: { datePicker, vuejsDatepicker },
  data() {
    return {
      fromDateModel: '',
      toDateModel: '',
      fromSentDateModel: '',
      toSentDateModel: '',
      contactTypes: ['面接案内', 'カジュアル面談', '応募案内', '通知のみ'],
      responseTypes: ['面接参加', 'カジュアル面談', '選考応募', '通知のみ', '応募見合わせ'],

      // userResponseModel: [],
      contactTypeModel: [],
      jobQueryModel: '',
      senderModel: '',
      disableFunction: {
        customPredictor(date) {
          if (date > new Date()) {
            return true;
          }
        },
      },
    };
  },
  computed: {
    ...mapState({
      sentSearchParams: ({ contact }) => contact.sentSearchParams,
    }),
    ...mapGetters({
      getClientStatus: 'getClientStatus',
      sentSearchParams: 'getSentSearchParams',
      loading: 'getLoading',
      getSentStatusModel: 'getSentStatusModel',
      getUserResponseModel: 'getUserResponseModel',
    }),
    statusModel: {
      get() {
        return this.getSentStatusModel;
      },
      set(value) {
        this.setSentStatusModel(value);
      },
    },
    userResponseModel: {
      get() {
        return this.getUserResponseModel;
      },
      set(value) {
        this.setUserResponseModel(value);
      },
    },
  },
  methods: {
    ...mapMutations([
      'setSentStatusModel',
      'setSentContacts',
      'setSentContactsPagination',
      'setSentSearchParams',
      'setLoading',
      'toggleSearchModal',
      'setUserResponseModel',
      'setSentPage',
    ]),
    ...mapActions(['loadSentContacts']),
    handleSearch() {
      // Handle search logic here
      this.$emit('search', this.searchQuery);
    },
    hideModal() {
      this.toggleSearchModal(false);
      this.$refs.modal.hide();
    },
    handleSearch() {
      const searchParams = this.buildParams(1);
      this.setSentSearchParams(searchParams);
      this.setSentPage(1);
      this.toggleSearchModal(false);
      this.$refs.modal.hide();
    },
    buildParams() {
      // console.log(this.statusModel);
      const params = {};
      params.registrationDateFrom = this.fromDateModel || null;
      params.registrationDateTo = this.toDateModel || null;
      params.sentDateFrom = this.fromSentDateModel || null;
      params.sentDateTo = this.toSentDateModel || null;
      params.contact_type = this.contactTypeModel || null;
      params.user_response = this.userResponseModel || null;
      params.jobQuery = this.jobQueryModel || null;
      params.sender = this.senderModel || null;
      params.status = this.statusModel || null;
      params.page = 1;
      return params;
    },
    prepopulateModels() {
      this.fromDateModel = this.sentSearchParams.registrationDateFrom
        ? this.sentSearchParams.registrationDateFrom
        : this.fromDateModel;
      this.toDateModel = this.sentSearchParams.registrationDateTo
        ? this.sentSearchParams.registrationDateTo
        : this.toDateModel;
      this.fromSentDateModel = this.sentSearchParams.sentDateFrom
        ? this.sentSearchParams.sentDateFrom
        : this.fromSentDateModel;
      this.toSentDateModel = this.sentSearchParams.sentDateTo
        ? this.sentSearchParams.sentDateTo
        : this.toSentDateModel;
      this.contactTypeModel = this.sentSearchParams.contact_type
        ? this.sentSearchParams.contact_type
        : this.contactTypeModel;
      // this.userResponseModel = this.sentSearchParams.user_response ? this.sentSearchParams.user_response : this.userResponseModel;
      this.jobQueryModel = this.sentSearchParams.jobQuery
        ? this.sentSearchParams.jobQuery
        : this.jobQueryModel;
      this.senderModel = this.sentSearchParams.sender
        ? this.sentSearchParams.sender
        : this.senderModel;
      // this.statusModel = this.sentSearchParams.status ? this.sentSearchParams.status : this.statusModel;
    },
  },
  mounted() {
    this.$refs.modal.show();
    this.prepopulateModels();
  },
};
</script>

<style scoped>
>>> .modal-header {
  border-bottom: none !important;
}

>>> .modal-lg {
  max-width: 950px !important;
}
.form-control input::placeholder {
  color: #787878;
  font-size: 14px !important;
}


.contact-search {
  padding: 20px 0;
}

.form-group {
  margin-bottom: 1rem;
}

.btn {
  padding: 8px !important;
  /* border-radius: 5px !important; */
}
h3 {
  color: #3c3c3c !important;
  font-weight: 700 !important;
  min-width: 150px;
}
a {
  color: #2bb2ab !important;
  font-weight: 700 !important;
}
label {
  color: #3c3c3c;
}

.notification-note {
  font-size: 11px;
  color: #787878;
  margin-top: 2px;
  line-height: 1.3;
}

.application-suspension-label {
  margin-top: -35px;
}
</style>
